import { render, staticRenderFns } from "./ConfirmSeats.vue?vue&type=template&id=1d71e1e3&"
import script from "./ConfirmSeats.vue?vue&type=script&lang=js&"
export * from "./ConfirmSeats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports